import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const HomeCarIcon = _ref => {
  let {
      size = "18",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    "clip-path": "url(#clip0_25809_57033)"
  }, __jsx("path", {
    d: "M25.7267 8.51317C25.46 7.7265 24.7133 7.1665 23.8333 7.1665H9.16667C8.28667 7.1665 7.55333 7.7265 7.27333 8.51317L4.5 16.4998V27.1665C4.5 27.8998 5.1 28.4998 5.83333 28.4998H7.16667C7.9 28.4998 8.5 27.8998 8.5 27.1665V25.8332H24.5V27.1665C24.5 27.8998 25.1 28.4998 25.8333 28.4998H27.1667C27.9 28.4998 28.5 27.8998 28.5 27.1665V16.4998L25.7267 8.51317ZM10.5 21.8332C9.39333 21.8332 8.5 20.9398 8.5 19.8332C8.5 18.7265 9.39333 17.8332 10.5 17.8332C11.6067 17.8332 12.5 18.7265 12.5 19.8332C12.5 20.9398 11.6067 21.8332 10.5 21.8332ZM22.5 21.8332C21.3933 21.8332 20.5 20.9398 20.5 19.8332C20.5 18.7265 21.3933 17.8332 22.5 17.8332C23.6067 17.8332 24.5 18.7265 24.5 19.8332C24.5 20.9398 23.6067 21.8332 22.5 21.8332ZM8.24667 13.8332L9.63333 9.83317H23.3533L24.74 13.8332H8.24667Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_25809_57033"
  }, __jsx("rect", {
    width: "32",
    height: "32",
    fill: "white",
    transform: "translate(0.5 0.5)"
  }))));
};
export default HomeCarIcon;